import React from 'react';
import styles from './chat.module.css';
const ListLoader = () => {
  return <div className={styles.listLoader}></div>;
};

export default ListLoader;
